import { render, staticRenderFns } from "./productCommission.vue?vue&type=template&id=1de0a550&scoped=true&"
import script from "./productCommission.vue?vue&type=script&lang=js&"
export * from "./productCommission.vue?vue&type=script&lang=js&"
import style0 from "./productCommission.vue?vue&type=style&index=0&id=1de0a550&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de0a550",
  null
  
)

export default component.exports